import { render, staticRenderFns } from "./UserPhoto.vue?vue&type=template&id=7d20220e&"
import script from "./UserPhoto.vue?vue&type=script&lang=ts&"
export * from "./UserPhoto.vue?vue&type=script&lang=ts&"
import style0 from "./UserPhoto.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports